export const formatPhone = (value: string) => {
  if (!value) return "";
  const digitsOnly = value.replace(/\D/g, "");
  const match = digitsOnly.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return digitsOnly;
};
